module.exports = __webpack_public_path__ + "img/logo.253e059e.svg";